import Vue from "vue";
import initService from "./init-service";

let baseurl = `${process.env.VUE_APP_CONFIG_BASEURL}`;
let apikey = `${process.env.VUE_APP_CONFIG_APIKEY}`;
let customer = initService.getCustomerInfo();
let headers = {
  headers: {
    "Content-Type": "application/json",
    "x-api-key": apikey,
  },
};

const troubleshootingService = {
  getDiscrepancyCheck() {
    let url = `${baseurl}?method=hlr_discrepancyReport&customer=${customer}`;
    return Vue.axios
      .get(url, headers)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
  sendHlrReset(imsi, hlr, vlr, sgsn) {
    let url = `${baseurl}?method=IOT_HLRReset&customer=${customer}&imsi=${imsi}&hlr=${hlr}&vlr=${vlr}&sgsn=${sgsn}`;
    return Vue.axios
      .get(url, headers)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
  sendHlrRestart(target) {
    let url = `${baseurl}?method=hlr_Restart&customer=${customer}&target=${target}`;
    return Vue.axios
      .get(url, headers)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
  getApnTypes() {
    let url = `${baseurl}?method=ggsn_listApns`;
    return Vue.axios
      .get(url, headers)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
  getGgsnSubscriber(apn, imsi) {
    let url = `${baseurl}?method=ggsn_listSubscribers&imsi=${imsi}&apn=${apn}`;
    return Vue.axios
      .get(url, headers)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
  getSmsMtQueue(imsi, msisdn) {
    let url = `${baseurl}?method=sms_searchMtQueue&customer=${customer}&imsi=${imsi}&msisdn=${msisdn}`;
    return Vue.axios
      .get(url, headers)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
  getSearchSmsLog(searchTerm) {
    let url = `${baseurl}?method=sms_searchLogs&customer=${customer}&term=${searchTerm}`;
    return Vue.axios
      .get(url, headers)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
  getSearchSmsPrefixes(searchTerm) {
    let url = `${baseurl}?method=sms_searchPrefixes&customer=${customer}&term=${searchTerm}`;
    return Vue.axios
      .get(url, headers)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
  getSubscriberUsageData(imsi, startDate, endDate, resolution) {
    let url = `${baseurl}?method=GetChartData&customer=${customer}&from_date=${startDate}&to_date=${endDate}&imsi=${imsi}&resolution=${resolution}`;
    return Vue.axios
      .get(url, headers)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
  getDataVolumeSummaryByRegion(imsi, period) {
    if (!imsi) imsi = '';
    let url = `${baseurl}?method=IOT_GetDataVolumeSummaryByRegion_map&imsi=${imsi}&period=${period}`;
    return Vue.axios
      .get(url, headers)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
};

export default troubleshootingService;
